<script setup lang="ts">
/**
 * A text field bound with `v-model`. `invalid` sets `aria-invalid`, which is also
 * what `widget.css` paints the error border from.
 *
 * The attributes it forwards are DECLARED, not left to fall through, so a typo at
 * a call site is a vue-tsc error rather than an attribute nobody reads.
 */
defineProps<{
  readonly id?: string | undefined;
  readonly type?: 'text' | 'email' | 'tel' | undefined;
  readonly required?: boolean | undefined;
  readonly maxlength?: number | undefined;
  readonly autocomplete?: string | undefined;
  readonly placeholder?: string | undefined;
  readonly disabled?: boolean | undefined;
  readonly invalid?: boolean | undefined;
  readonly describedBy?: string | undefined;
}>();

const model = defineModel<string>({ required: true });
</script>

<template>
  <input
    :id="id"
    v-model="model"
    :type="type ?? 'text'"
    :required="required"
    :maxlength="maxlength"
    :autocomplete="autocomplete"
    :placeholder="placeholder"
    :disabled="disabled"
    :aria-invalid="invalid === true ? true : undefined"
    :aria-describedby="describedBy"
  />
</template>
